import parsePhoneNumber, { AsYouType, CountryCode } from 'libphonenumber-js'

export const isValidPhoneNumber = (value: string, defaultCountryCode: CountryCode = "US" ): boolean => {
    const phoneNumber = parsePhoneNumber(value, defaultCountryCode);
    if (!phoneNumber) {
        return false;
    }
    return parsePhoneNumber(value, defaultCountryCode).isValid();
};

export const phoneNumberToE164 = (value: string, defaultCountryCode: CountryCode = "US" ): string | undefined => {
    const phoneNumber = parsePhoneNumber(value, defaultCountryCode);
    if (phoneNumber) {
        return phoneNumber.format("E.164");
    }
};
  
export function formatPhoneNumber(value: string, defaultCountryCode?: CountryCode ): string {
    return new AsYouType(defaultCountryCode).input(value);
};
